<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1jFHSo/tc-custom/9781459219557.jpg?1700958117781" alt="This image is the cover for the book Captured for the Captain's Pleasure"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Captured for the Captain's Pleasure
      </h1>
      <p class="bookDescription body article font2">
        <p>Captain Michael Hawkhurst relishes his fearsome reputation, for he lives only to wreak revenge on the  Fulton family, who so cruelly destroyed his own.<br/><br/>Spirited Alice Fulton knows a ship is no place for a lady, but she is determined to save her father's business.<br/><br/>When fate delivers him Fulton's virginal daughter as his captive, Michael faces a dilemmashould he live up to his scandalous name and find revenge with sweet Alice, or will his honorable side win outand win the girl?<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ann Lethbridge
      </h2>
      
      <p class="authorDescription body article">Ann Lethbridge majored in history and business. She always loved the glamorous, if rather risky, Georgians and in particular the Regency era as drawn by Georgette Heyer. It was that love that prompted her to write her first Regency novel in 2000. She found she enjoyed it so much she just couldn&rsquo;t stop! Ann gave up a career in university administration to focus on her first love, writing novels and lives in Canada with her family. Visit her website at: www.annlethbridge.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?59686657